import api from './api';

/**
 * Email service for verification and drafting operations
 */

/**
 * Verify email addresses for contacts in a campaign
 * 
 * @param {string} campaignId - Campaign ID
 * @param {string} versionId - Version ID
 * @param {Array<string>} contactIds - Optional array of contact elasticsearch_ids to verify.
 *                                     If provided, only these contacts will be verified.
 *                                     If not provided, all contacts in the campaign will be verified.
 * @returns {Promise} - Verification results
 */
export const verifyEmails = async (campaignId, versionId, contactIds = null) => {
  const params = new URLSearchParams({ version_id: versionId });
  
  const body = contactIds ? { contact_ids: contactIds } : {};
  
  return api.post(`/api/emails/${campaignId}/verify-emails?${params.toString()}`, body);
};

/**
 * Preview email drafts (5 samples) via SSE
 * Note: This is handled by useSSEStream, but included for reference
 * 
 * @param {string} campaignId - Campaign ID
 * @param {string} versionId - Version ID
 * @param {Object} draftingParams - Drafting parameters
 * @param {string} configId - Config ID for iteration (optional)
 * @returns {string} - SSE endpoint URL
 */
export const getPreviewEmailDraftsUrl = (campaignId) => {
  return `/api/emails/${campaignId}/draft-emails/preview/stream`;
};

/**
 * Approve email drafts and run full generation via SSE
 * Note: This is handled by useSSEStream, but included for reference
 * 
 * @param {string} campaignId - Campaign ID
 * @param {string} configId - Config ID to approve
 * @returns {string} - SSE endpoint URL
 */
export const getApproveEmailDraftsUrl = (campaignId, configId) => {
  return `/api/emails/${campaignId}/configs/${configId}/approve/stream`;
};

export default {
  verifyEmails,
  getPreviewEmailDraftsUrl,
  getApproveEmailDraftsUrl,
};

